export default __webpack_public_path__ + "images/SX.60e3951.png";